<template>
  <b-modal
    id="cancel-charge"
    ref="cancel-charge"
    title="Charge cancellation"
    centered
    ok-title="Save"
    ok-only
    size="md"
    @ok="handleForm"
    @hidden="resetModal"
  >
    <validation-observer
      ref="userRules"
      tag="form"
    >
      <div
        class="p-2 text-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          class="mb-2"
          viewBox="0 0 80 80"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.3335 39.9999C3.3335 60.3332 19.6668 76.6666 40.0002 76.6666C60.3335 76.6666 76.6668 60.3332 76.6668 39.9999C76.6668 19.6666 60.3335 3.33325 40.0002 3.33325C19.6668 3.33325 3.3335 19.6666 3.3335 39.9999ZM10.0002 39.9999C10.0002 23.3333 23.3335 9.99992 40.0002 9.99992C56.6668 9.99992 70.0002 23.3333 70.0002 39.9999C70.0002 56.6666 56.6668 69.9999 40.0002 69.9999C23.3335 69.9999 10.0002 56.6666 10.0002 39.9999ZM43.3335 39.9999V26.6666C43.3335 24.6666 42.0002 23.3333 40.0002 23.3333C38.0002 23.3333 36.6668 24.6666 36.6668 26.6666V39.9999C36.6668 41.9999 38.0002 43.3333 40.0002 43.3333C42.0002 43.3333 43.3335 41.9999 43.3335 39.9999ZM43.0002 54.6666C43.0002 54.9999 42.6668 55.3333 42.3335 55.6666C41.6668 56.3333 41.0002 56.6666 39.6668 56.6666C38.6668 56.6666 38.0002 56.3333 37.3335 55.6666C36.6668 54.9999 36.3335 54.3333 36.3335 53.3333C36.3335 52.9427 36.4479 52.6666 36.5426 52.4378C36.6096 52.2761 36.6668 52.138 36.6668 51.9999C36.6668 51.6666 37.0002 51.3333 37.3335 50.9999C38.3335 49.9999 39.6668 49.6666 41.0002 50.3333C41.1668 50.3333 41.2502 50.4166 41.3335 50.4999C41.4168 50.5832 41.5002 50.6666 41.6668 50.6666C42.0002 50.6666 42.3335 50.9999 42.3335 50.9999C42.5002 51.1666 42.5835 51.3332 42.6668 51.4999C42.7502 51.6666 42.8335 51.8332 43.0002 51.9999C43.3335 52.3333 43.3335 52.9999 43.3335 53.3333C43.3335 53.4999 43.2502 53.7499 43.1668 53.9999C43.0835 54.2499 43.0002 54.4999 43.0002 54.6666Z"
            fill="black"
          />
          <mask
            id="mask0"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="3"
            y="3"
            width="74"
            height="74"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.3335 39.9999C3.3335 60.3332 19.6668 76.6666 40.0002 76.6666C60.3335 76.6666 76.6668 60.3332 76.6668 39.9999C76.6668 19.6666 60.3335 3.33325 40.0002 3.33325C19.6668 3.33325 3.3335 19.6666 3.3335 39.9999ZM10.0002 39.9999C10.0002 23.3333 23.3335 9.99992 40.0002 9.99992C56.6668 9.99992 70.0002 23.3333 70.0002 39.9999C70.0002 56.6666 56.6668 69.9999 40.0002 69.9999C23.3335 69.9999 10.0002 56.6666 10.0002 39.9999ZM43.3335 39.9999V26.6666C43.3335 24.6666 42.0002 23.3333 40.0002 23.3333C38.0002 23.3333 36.6668 24.6666 36.6668 26.6666V39.9999C36.6668 41.9999 38.0002 43.3333 40.0002 43.3333C42.0002 43.3333 43.3335 41.9999 43.3335 39.9999ZM43.0002 54.6666C43.0002 54.9999 42.6668 55.3333 42.3335 55.6666C41.6668 56.3333 41.0002 56.6666 39.6668 56.6666C38.6668 56.6666 38.0002 56.3333 37.3335 55.6666C36.6668 54.9999 36.3335 54.3333 36.3335 53.3333C36.3335 52.9427 36.4479 52.6666 36.5426 52.4378C36.6096 52.2761 36.6668 52.138 36.6668 51.9999C36.6668 51.6666 37.0002 51.3333 37.3335 50.9999C38.3335 49.9999 39.6668 49.6666 41.0002 50.3333C41.1668 50.3333 41.2502 50.4166 41.3335 50.4999C41.4168 50.5832 41.5002 50.6666 41.6668 50.6666C42.0002 50.6666 42.3335 50.9999 42.3335 50.9999C42.5002 51.1666 42.5835 51.3332 42.6668 51.4999C42.7502 51.6666 42.8335 51.8332 43.0002 51.9999C43.3335 52.3333 43.3335 52.9999 43.3335 53.3333C43.3335 53.4999 43.2502 53.7499 43.1668 53.9999C43.0835 54.2499 43.0002 54.4999 43.0002 54.6666Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0)">
            <rect
              width="80"
              height="80"
              fill="#FF9F43"
            />
          </g>
        </svg>
        <b-card-title
          class="mb-2 font-weight-bold"
          title-tag="h2"
        >
          Canceling the charge will affect some payments
        </b-card-title>
        <!-- <b-card-text class="mb-2 text-left">
          <b-form-radio
            v-model="selectedMethod"
            name="some-radios"
            value="payment"
            class="mb-1"
          >
            Refund to Original Payment Method
          </b-form-radio>
          <b-form-radio
            v-model="selectedMethod"
            name="some-radios"
            value="balance"
          >
            Refund to Account Balance
          </b-form-radio>
        </b-card-text> -->

        <b-card-text class="mb-2 text-left">
          <b-form-group
            label="Reason"
          >
            <validation-provider
              #default="{ errors }"
              name="Reason"
              rules="required"
            >
              <v-select
                id="reason"
                v-model="reason"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="reasonOptions"
                :clearable="false"
                placeholder="Select a reason"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-card-text>

        <b-card-text
          v-if="reason == 'Other'"
          class="mb-2 text-left"
        >
          <b-form-group
            label="Description"
          >
            <validation-provider
              #default="{ errors }"
              name="Description"
              rules="required"
            >
              <b-form-textarea
                v-model="description"
                no-resize
                placeholder="Your text"
                :state="errors.length > 0 ? false : null"
                size="lg"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-card-text>
      </div>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BCardTitle, BCardText, BFormGroup, BFormTextarea, VBModal,
  // BFormRadio,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,

    BCardTitle,
    BCardText,
    // BFormRadio,
    BFormGroup,
    BFormTextarea,

    vSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      selectedMethod: 'payment',
      reason: '',
      reasonOptions: ['Duplicate', 'Order Change', 'Other'],
      description: '',
      required,
    }
  },
  methods: {
    async handleForm(bvModalEvt) {
      bvModalEvt.preventDefault()

      await this.$refs.userRules.validate()
        .then(success => {
          if (success) {
            this.confirm()
          }
        })
    },
    confirm() {
      const queryParams = {
        reason: this.reason,
        // method: this.selectedMethod,
      }
      if (this.reason === 'Other') {
        queryParams.reason = this.description
      }
      this.$emit('confirm', queryParams)
      this.$bvModal.hide('cancel-charge')
    },
    resetModal() {
      this.reason = ''
      this.description = ''
      this.selectedMethod = 'payment'
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
